import { useState, useEffect } from "react";
import { formatNumber, isNumeric, stringToNumber } from "../helpers/utils"

const NumericQuestion = ({ question, responses, saveResponse, compact }) => {

    const [value, setValue] = useState("");

    const onNumericBlur = (questionId, value) => {
        value = value.replace(/[^0-9.]/g, "");
        let number;
        if (!isNumeric(value)) {
            number = question.minValue;
        } else {
            number = Math.min(question.maxValue, Math.max(question.minValue, stringToNumber(value)));
        }
        const params = {
            surveyQuestionId: question.surveyQuestionId,
            questionId: parseInt(questionId, 10),
            numericResponse: number
        }
        saveResponse(params);
    }
    const onNumericChange = (n) => {
        // first, strip all characters other than 0-9 and .
        n = n.replace(/[^0-9.]/g, "");

        // cache this special case, if the last character of the user's input is the decimal point

        const specialCase = (n.at(-1) === ".");

        // Split n on "." into an array.
        // There should be either 1 or 2 items in the array, but there might be more
        // if the user has entered more than one decimal point.
        // The first item is the whole number; the remaining items are combined to become the decimal part.

        const parts = n.split(".");

        const whole = parts.shift();
        const decimal = parts.join("");

        let formatted;

        if ((decimal === "") && specialCase) {
            formatted = formatNumber(whole) + ".";
        } else if (decimal === "") {
            formatted = formatNumber(whole);
        } else {
            formatted = formatNumber(whole) + "." + decimal;
        }
        setValue(formatted);
    }

    useEffect(() => {
        let value = 0;
        for (let response of responses) {
            if (response.questionId === question.questionId) {
                value = response.response;
                break;
            }
        }
        const formatted = formatNumber(value, question.decimalPlaces);
        // console.log(`setting numericResponse to value: ${value} formatted: ${formatted}`);
        // console.log(question);
        setValue(formatted);
    }, [question, responses])

    const maxLength = (formatNumber(question.maxValue, question.decimalPlaces)).length + 1;

    return (
        <div className={`numeric-input ${compact ? "compact" : ""}`}>
            <input className={`numeric ${compact ? "compact" : ""} ${question.type}`} type="text" id={question.questionId} name={question.questionId} maxLength={maxLength} size={maxLength} autoComplete="off" value={value} onChange={(e) => onNumericChange(e.target.value)} onFocus={(e) => e.target.select()} onBlur={(e) => onNumericBlur(question.questionId, e.target.value)} />
        </div>
    )

};


export default NumericQuestion;